<div
  class="flex flex-row-reverse items-center justify-start flex-1 min-w-0 gap-2 max-sm:flex-row max-sm:justify-start"
>
  <img alt="logo" [src]="getLogoImg()" class="logo-sm" />

  @if(screenService.isMobile()){
  <div
    class="max-w-full text-end max-sm:text-start overflow-hidden min-w-0 block"
  >
    <span
      class="truncate cursor-pointer hover:underline block text-wrap"
      [class.font-roboto-500]="isWin()"
      [attr.title]="getTraduccionName()"
    >
      {{ getTraduccionName() }}
    </span>
  </div>
  }@else {
  <a
    class="max-w-full text-end max-sm:text-start overflow-hidden min-w-0 block"
    (click)="$event.preventDefault(); $event.stopPropagation()"
    [routerLink]="getUrlTeam()"
  >
    <span
      class="truncate cursor-pointer hover:underline block text-wrap"
      [class.font-roboto-500]="isWin()"
      [attr.title]="getTraduccionName()"
    >
      {{ getTraduccionName() }}
    </span>
  </a>
  }

  <div class="justify-end hidden min-w-[25px] max-sm:flex max-sm:ml-auto">
    <span class="text-end" [class.text-red-2]="isLiveMatch()">
      {{ awayTeam()?.penaltyScore && "(" + awayTeam()?.penaltyScore + ")" }}
      {{ awayTeam()?.score }}
    </span>
  </div>
</div>
